module.exports = __webpack_public_path__ + "img/bg_2.671d5395.jpg";